import { ReduxService } from 'dashboard-services/services';
import TimeService from 'dashboard-services/services/TimeService';

import { commonDatalakeActions } from 'actions/modules/datalake';
import { builderDataStorageCreatorActions } from 'actions/modules/dataStorage/creator';
import { selectedUserSettingsActions, settingsMyAccountActions } from 'actions/modules/myAccount';
import { routing } from 'routing';

export const selectedUserSettingsInitialState = {
  columns: [],
  companyTags: [],
  symbolsDisplay: {},

  dashboardUserTabs: [],
  defaultGroup: undefined,
  defaultPage: undefined,
  definedTime: TimeService.UTC,
  downloadFormat: builderDataStorageCreatorActions.basicDownloadFormats[0],
  additionalParameters: "false",
  storageScreen: routing.dataStorage.routing.creator.hashes.table,
  userName: "",
  storageGroupsHidden: false,
  datalakeLayout: commonDatalakeActions.DATALAKE_LAYOUT.VERSIONS,

  favoritePipelines: [],
  favoriteGroups: [],
  favoriteInsights: [],
  favoriteDataPreps: [],

  recents: [],
  recentTasks: [],
  colorPalettes: [],
  formulaPanelRecents: [],
  formulaPanelConstants: [],

  darkmode: settingsMyAccountActions.DARK_MODE.OFF
}

export default (state = selectedUserSettingsInitialState, action) => {
  switch (action.type) {
    case selectedUserSettingsActions.ON_CHANGE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    case selectedUserSettingsActions.CLEAN_ALL:
      return selectedUserSettingsInitialState;
    default:
      return state; 
  }
}